export const formatErrorMessage = (message: string): string =>
  message.endsWith('.') ? message : `${message}.`;

